<wr-base-dialog [status]="status" [header]="header">
  {{message}}
</wr-base-dialog>
